"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SuperAgentThrottle = require("superagent-throttle/dist/browser");
/**
 * Create a Throttle class and assign it to each of the API clients to restrict the number of requests
 * that can be made per second, thereby preventing TooManyRequests errors from being returned by the API's
 * rate limiting defenses.
 */
var Throttle = (function () {
    /**
     * @param  {number} requestPerSecond The maximum number of requests per second to allow.
     * @param  {number} concurrency      The maximum number of requests to do in parallel.
     */
    function Throttle(requestPerSecond, concurrency) {
        this.throttle = new SuperAgentThrottle({
            active: true,
            rate: requestPerSecond,
            ratePer: 1000,
            concurrent: concurrency,
        });
    }
    Throttle.prototype.apply = function (request) {
        request.use(this.throttle.plugin());
    };
    return Throttle;
}());
exports.Throttle = Throttle;
//# sourceMappingURL=throttle.js.map